/**
 * Created by rathompson on 12/29/21
 * File: Collapse
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

/**
 *   Collapsable component
 */
const Collapse = ({ isOpen: _isOpen, duration, children, openClassName = '' }) => {
  const outerRef = useRef(null)
  const content = useRef(null)
  const [height, setHeight] = useState(null)
  const [isOpen, setIsOpen] = useState(_isOpen)

  useEffect(() => {
    const clientHeight = content?.current?.clientHeight || 0
    if (outerRef && outerRef.current) {
      outerRef.current.ontransitionend = () => {
        if (isOpen) {
          setHeight('max-content')
        }
      }
    }
    setHeight(`${clientHeight}px`)
  }, [isOpen])

  useEffect(() => {
    const clientHeight = content?.current?.clientHeight || 0
    if (!_isOpen && height === 'max-content') {
      setHeight(`${clientHeight}px`)
      return
    }
    setIsOpen(_isOpen)
  }, [_isOpen, height])

  return (
    <div
      ref={outerRef}
      className={`tw-transition-all tw-overflow-hidden tw-duration-${duration} tw-ease-out ${isOpen ? openClassName : ''}`.trim()}
      style={{ maxHeight: isOpen ? height : 0 }}>
      <div ref={content}>{children}</div>
    </div>
  )
}

Collapse.propTypes = {
  isOpen: PropTypes.bool,
  duration: PropTypes.oneOf([
    75,
    100,
    150,
    200,
    300,
    500,
    700,
    1000
  ])
}

Collapse.defaultProps = {
  isOpen: false,
  duration: 300
}

export default Collapse
